import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useState } from 'react';
import UserOnglet from "../../user/UserOnglet";
import UserGoBack from "../../user/UserGoBack";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicGestionOrg = () => {
  const { setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const isSmallDevise = windowWidth < 900;  
  
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Besoin de modifier les informations de votre entreprise ou association ? Pas de problème. 
              Vous pouvez modifier vos informations à partir de votre compte personnel.
            </p>
            <p className="help-text">
              Si vous devez mettre à jour les informations commerciales qui doivent être vérifiées pour vous conformer aux exigences 
              légales (telles que le nom légal de votre entreprise ou les informations d'enregistrement de votre entreprise), 
              nous vous demanderons de confirmer que nous devrons vérifier vos nouvelles informations avant de pouvoir continuer.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Cliquez sur <strong>Profil</strong> {'>'} <strong>Compte</strong> {'>'}
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>Paiements et versements.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Accédez à la section <strong>Versement.</strong></p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Pour des modifications cliquez sur le lien dans la liste. Vous y verrez le status de votre compte (incomplet, terminé). 
                          Laissez-vous ensuite guider pour affectuer les démarches necessaires.
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Pour ajouter un nouveau compte bancaire, cliquez sur <strong>Ajouter un versement</strong>.</p>
                      </li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <ol>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Appuyer dans le navbar sur votre <strong>Avatar</strong> ou sur <i className="fa-solid fa-bars fz-18 ml-8 mr-8"></i> {'>'} 
                          <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>Mon Compte.</a>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Dans Paramètres du compte {'>'} Compte {'>'} <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/payments`}>Paiments et versements.</a></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Appuyez sur la section <strong>Versement.</strong></p></li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Pour des modifications appuyer sur le lien dans la liste. Vous y verrez le status de votre compte (incomplet, terminé). 
                          Laissez-vous ensuite guider pour affectuer les démarches necessaires.
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Pour ajouter un nouveau compte bancaire, appuyer sur <strong>Ajouter un versement.</strong></p>
                      </li>
                    </ol>
                  </div>
              }
              <p className="help-text mt-32">
                Wodzone s'associe avec Stripe pour garantir votre sécurité dans vos paiements.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicGestionOrg